module.exports = __webpack_public_path__ + "res/7-img_game_bg.04c9e51ecdaf07bae7829c5d449d53d4.png";